import type { Snapshot } from "@app/protocol";

/**
 * The players to report gone (slice 0024): seated humans at a running table who were in this
 * Activity instance and are not any more. Never yourself; the server asks Discord before acting. Pure.
 */
export function departures(
  before: ReadonlySet<string>,
  after: ReadonlySet<string>,
  snapshot: Snapshot,
  self: string,
): string[] {
  if (snapshot.table.status !== "playing") return [];
  return snapshot.table.seats
    .filter((seat) => seat !== null && !seat.bot)
    .map((seat) => seat?.userId ?? "")
    .filter((userId) => userId !== self && before.has(userId) && !after.has(userId));
}
